import { gql } from '@apollo/client'

export const GET_SHOWROOMS = gql`
  query GetShowrooms($isPickupOnly: Boolean) {
    showrooms(isPickupOnly: $isPickupOnly) {
      items {
        id
        name
        address
        open_hours {
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          sunday
        }
        images
        contact {
          email
          fax
          phone
        }
      }
    }
  }
`
